import mockProfile from '../../__mockData/mockProfile.json';
import { DynamicObjectInterface } from '../type';
import { axiosGet, axiosPatch, axiosPost, axiosPut } from './axiosUtils';
import './axiosInterceptor';

const userService = {
  async createUser(user: DynamicObjectInterface) {
    return await axiosPost(`user/create`, user);
  },

  async getUser() {
    return await axiosGet(`user/profile`, mockProfile);
  },

  async updateUser(userId: string, user: DynamicObjectInterface) {
    return await axiosPut(`user/profile/${userId}`, user);
  },

  async updateUserPartyId(user: DynamicObjectInterface) {
    return await axiosPut(`/user/profileParty`, user);
  },

  async updateUserProfile(userId: string, user: DynamicObjectInterface) {
    return await axiosPut(`/user/profileDetails/${userId}`, user);
  },

  async getUserDetails(id: string) {
    return await axiosGet(`user/list/${id}`);
  },

  async listUser() {
    return await axiosGet(`user/list`);
  },

  async deleteUser(selectedRowId: string) {
    return await axiosPatch(`user/profile/${selectedRowId}`);
  },
};
export default userService;
